import { render } from "./FinishTrail.vue?vue&type=template&id=3260ed50&scoped=true"
import script from "./FinishTrail.vue?vue&type=script&lang=js"
export * from "./FinishTrail.vue?vue&type=script&lang=js"

import "./FinishTrail.vue?vue&type=style&index=0&id=3260ed50&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3260ed50"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QImg,QCardSection,QItem,QItemSection,QItemLabel,QIcon,QSeparator,QCheckbox,QInnerLoading,QBtn});
